// src/context/SettingsContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { getSettingsData } from '../api/settingsApi';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem("app_settings");
    return saved ? JSON.parse(saved) : null;
  });
  
  const [loading, setLoading] = useState(!settings);

  useEffect(() => {
    let isMounted = true;

    const loadInitialSettings = async () => {
      try {
        const data = await getSettingsData();
        if (isMounted) {
          setSettings(data);
          // Menimpa localStorage lama dengan data terbaru (email & website baru)
          localStorage.setItem("app_settings", JSON.stringify(data));
        }
      } catch (error) {
        console.error("Gagal sinkronisasi settings:", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadInitialSettings();
    return () => { isMounted = false; };
  }, []);

  return (
    <SettingsContext.Provider 
      value={{ 
        loading, 
        logo: settings?.logoUrl,
        ...settings // Menyebarkan isi settings (contactEmail, officialWebsite, dll)
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);